<template>
  <div class="signup-container">
    <SignupFormVersion
      tracking="signup"
      :button-class=" $config.platform === 'fa' ? 'btn-primary-yellow' : 'btn-primary'"
      :title="$config.platform === 'fa' ? 'Start Learning For Free' : 'Create Your Free Account'"
    />
    <div>
      <div class="info-wrap">
        <h2 class="h1">
          Welcome To Our Community
        </h2>
        <p class="subtitle">
          Learn. Connect. Share your experience with more than 2 million students across the globe.
        </p>
        <p class="students">
          <img :src="getImg" alt="signup-users">
          <span>Join 2M Students</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import SignupFormVersion from '../components/Profile/Signup/SignupFormVersion';

export default {
  components: {
    SignupFormVersion,
  },
  mixins: [global],
  middleware({ store, redirect }) {
    if (store.state.auth.user) {
      redirect('/');
    }
  },
  async asyncData({ $axios, route, $config }) {
    const page = await $axios.$get(`/pages/${route.fullPath}`).catch(() => ({}));
    page.fullPath = `${$config.siteUrl}${route.fullPath}`;

    return {
      page,
    };
  },

  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
    ]);

    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps(this.page),
      script: [linkedData],
    };
  },
  computed: {
    getImg() {
      if (this.$config.platform === 'fa') {
        return require('../assets/images/fa/fa-signup-users.png');
      }
      return require('../assets/images/signup-users.png');
    },
  },
};

</script>
<style lang="scss">
.signup-container {
  min-height: 100vh;
  position: relative;

  .form-wrap {
    padding-top: var(--spacing-60);
    padding-left: 0;
    padding-right: 0;
    max-width: 332px;

    h1 {
      margin-bottom: var(--spacing-24);
    }
  }

  > div {
    min-height: inherit;
    float: left;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;

    > div {
      margin: auto;
    }

    &:first-of-type {
      background-color: var(--main-light);
      width: 46%;
    }

    &:last-of-type {
      width: 54%;
      background: linear-gradient(-253.23deg, rgba(0, 164, 178, 0.2) 0%, rgba(0, 164, 178, 0.05) 44.75%, rgba(0, 164, 178, 0) 94.77%);
      background-color: var(--main-dark);
    }

    .form-wrap {
      margin: auto;
    }

    .info-wrap {
      max-width: 400px;
      color: var(--main-light);

      .h1 {
        margin: 0;
        font-size: 48px;
      }

      .subtitle {
        margin-bottom: var(--spacing-48);
        margin-top: var(--spacing-16);
      }

      .students {
        margin: 0;
      }

      img {
        vertical-align: middle;
        margin-right: var(--spacing-24);
      }
    }
  }

  @include bp($bp-laptop) {
    > div .info-wrap .h1 {
      font-size: 44px;
    }
  }

  @include bp($bp-mobile) {
    padding: 148px 0 0;
    min-height: calc(100vh - 148px);
    margin: 0;

    > div {
      align-items: flex-start;
      justify-content: center;

      .form-wrap {
        margin: 0;
        padding-top: 0;
      }

      .signup-options {
        margin: 0;

        .form-wrap {
          margin: 0 auto;
        }
      }

      &:first-of-type {
        width: 100%;
      }

      &:last-of-type {
        display: none;
      }
    }
  }
}

@include bp($bp-laptop) {
  .signup-container {
    .form-wrap {
      max-width: 310px;
    }
  }
}

.fa {
  .signup-container > div:last-of-type {
    background: linear-gradient(135deg, rgba(3, 111, 253, 0.14) 19.77%, rgba(3, 111, 253, 0.05) 36.77%, rgba(1, 22, 51, 0) 63.97%);
    background-color: var(--main-dark);
  }
}
</style>
